const CryptoJS = require("crypto-js");



const metadataDecryptHandler = (dataString, key) => {
    const hashedKey = CryptoJS.SHA256(key);
    // Use the first 16 bytes of the hashed key for AES-128
    const truncatedKey = CryptoJS.lib.WordArray.create(hashedKey.words.slice(0, 4));
    // Decrypt the data using AES
    const decryptedData = CryptoJS.AES.decrypt(dataString, truncatedKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
}

export const EnvKeys = {
    backendToken: 'backendToken',
    backendUrl: 'backendUrl',
    billBackendUrl: 'billBackendUrl',
    billFrontendUrl: 'billFrontendUrl',
    credsBillTariffEmail: 'credsBillTariffEmail',
    credsBillTariffPassword: 'credsBillTariffPassword',
    credsVnueronPassword: 'credsVnueronPassword',
    credsVnueronUsername: 'credsVnueronUsername',
    secured: 'secured',
    tariffBackendUrl: 'tariffBackendUrl',
    tariffTestingUrl: 'tariffTestingUrl',
    tariffFrontendUrl: 'tariffFrontendUrl',
    vneuronBackendUrl: 'vneuronBackendUrl',
    vneuronFrontendUrl: 'vneuronFrontendUrl',
    tariffInternalUsername: 'tariffInternalUsername',
    tariffInternalPassword: 'tariffInternalPassword',
    tariffExternalUsername: 'tariffExternalUsername',
    tariffExternalPassword: 'tariffExternalPassword',
};

export const setEnvMetadataIntoLocalStorage = (metadata) => {
    localStorage.setItem('backendToken',metadata.backendToken);
    localStorage.setItem('billBackendUrl',metadata.billBackendUrl);
    localStorage.setItem('billFrontendUrl',metadata.billFrontendUrl);
    localStorage.setItem('credsBillTariffEmail', metadata.credsBillTariffEmail);
    localStorage.setItem('credsBillTariffPassword', metadata.credsBillTariffPassword);
    localStorage.setItem('credsVnueronPassword',metadata.credsVnueronPassword);
    localStorage.setItem('credsVnueronUsername',metadata.credsVnueronUsername);
    localStorage.setItem('secured', metadata.secured);
    localStorage.setItem('tariffBackendUrl',metadata.tariffBackendUrl);
    localStorage.setItem('tariffTestingUrl',metadata.tariffTestingUrl);
    localStorage.setItem('tariffFrontendUrl',metadata.tariffFrontendUrl);
    localStorage.setItem('vneuronBackendUrl',metadata.vneuronBackendUrl);
    localStorage.setItem('vneuronFrontendUrl',metadata.vneuronFrontendUrl);
    localStorage.setItem('tariffInternalUsername',metadata.tariffInternalUsername);
    localStorage.setItem('tariffInternalPassword',metadata.tariffInternalPassword);
    localStorage.setItem('tariffExternalUsername',metadata.tariffExternalUsername);
    localStorage.setItem('tariffExternalPassword',metadata.tariffExternalPassword);
}

export const getEnvItem = (envKey) => {
    if(localStorage.getItem(EnvKeys.secured)==='true'){
        return metadataDecryptHandler(localStorage.getItem(envKey), localStorage.getItem("authToken"));
    }else{
        return localStorage.getItem(envKey);
    }


}